<template>
  <div class="mainbox" style="background:#f4f4f4">
    <div
      data-aos="fade-left"
      data-aos-delay="200"
      data-aos-easing="ease-in-out"
      data-aos-anchor-placement="top-bottom"
      data-aos-offset="120"
    >
      <h2 class="tit">{{lang[local].part3_txt1}}</h2>
      <p class="subtit">
        {{lang[local].part3_txt2}}
        <br>
        {{lang[local].part3_txt3}}
      </p>
      <div class="sb">
        <div>
          <dl>
            <dt>
              <i class="iconfont icon-baifenbi"></i>
              {{lang[local].part3_txt4}}
            </dt>
            <dd>{{lang[local].part3_txt5}}</dd>
          </dl>
          <dl>
            <dt>
              <i class="iconfont icon-wuliutouming"></i>
              {{lang[local].part3_txt6}}
            </dt>
            <dd>{{lang[local].part3_txt7}}</dd>
          </dl>
        </div>
        <div>
          <dl>
            <dt>
              <i class="iconfont icon-anquan"></i>
              {{lang[local].part3_txt8}}
            </dt>
            <dd>{{lang[local].part3_txt9}}</dd>
          </dl>
          <dl>
            <dt>
              <i class="iconfont icon-rocket"></i>
              {{lang[local].part3_txt10}}
            </dt>
            <dd>{{lang[local].part3_txt11}}</dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: mapState(["lang", "local", "skin"]),
  mounted() {},
  methods: {}
  // render (h) {
  //     return (
  //     )
  // }
};
</script>

<style lang="less" scoped>
.sb {
  padding: 20px;
  overflow: hidden;
  font-size: 14px;
  div {
    overflow: hidden;
  }
  dl {
    width: 30%;
    margin: 0 10%;
    margin-top: 30px;
    float: left;
    dt {
      color: #e95b57;
      font-size: 18px;
      i {
        font-size: 40px;
        position: relative;
        top: 7px;
      }
    }
    dd {
      color: #8f8f8f;
      line-height: 30px;
    }
  }
}
</style>

